import ENV from "config/Env";
import { typedQueryClient, useTypedMutation } from "hooks";
import { KeyLockersQueryKeys } from "modules/KeyLockersDashboard/queryKeys";
import { ApiInstance } from "utils/Api";

import type { KeyLocker } from "models";

type CreateKeyLockerPayload = {
  name: string;
  location_id: number;
  is_2fa_to_drop_key_enabled: boolean;
};

type CreateKeyLockerResponse = KeyLocker & { private_key?: string };

export const useCreateKeyLockerMutation = () =>
  useTypedMutation<CreateKeyLockerPayload, CreateKeyLockerResponse>({
    mutationFn: async payload => (await ApiInstance.post("/dashboard/create", payload, ENV.keylockerBaseURL)).data,
    onSuccess: (_, response) => {
      const keyLockers = typedQueryClient.getQueryData(KeyLockersQueryKeys.keyLockers);

      const keyLockerIdx = keyLockers?.findIndex(keyLocker => keyLocker.id === response.id) ?? -1;
      if (keyLockerIdx > -1) return;

      typedQueryClient.setQueryData(KeyLockersQueryKeys.keyLockers, [...(keyLockers ?? []), response]);
    }
  });
